import { Routes, Route, NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { motion } from 'framer-motion'
import DashboardProjects from './pages/DashboardProjects'
import DashboardBio from './pages/DashboardBio'
import DashboardServices from './pages/DashboardServices'
import DashboardSocialLinks from './pages/DashboardSocialLinks'
import DashboardContent from './pages/DashboardContent'
import DashboardResume from './pages/DashboardResume'
import DashboardSettings from './pages/DashboardSettings'
import DashboardManagement from './pages/DashboardManagement'

const navItems = [
  { path: 'projects', label: 'Projects', icon: '📁' },
  { path: 'bio', label: 'Bio', icon: '👤' },
  { path: 'resume', label: 'Resume', icon: '📄' },
  { path: 'services', label: 'Services', icon: '💼' },
  { path: 'management', label: 'Management', icon: '📊' },
  { path: 'social', label: 'Social Links', icon: '🔗' },
  { path: 'content', label: 'Content', icon: '📝' },
  { path: 'settings', label: 'Settings', icon: '⚙️' },
]

const springConfig = { type: "spring", stiffness: 60, damping: 10 }

export default function Dashboard() {
  const { user, signOut } = useAuth()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    await signOut()
    navigate('/')
  }

  return (
    <div className="min-h-screen bg-background">
      {/* Dashboard Header */}
      <header className="glass border-b border-text-primary/10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
            <h1 className="text-xl sm:text-2xl font-semibold text-gradient-glow font-display">
              Dashboard
            </h1>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 w-full sm:w-auto">
              <span className="text-text-primary/70 text-xs sm:text-sm break-all">{user?.email}</span>
              <motion.button
                onClick={handleSignOut}
                className="px-4 py-2.5 neu rounded-xl text-text-primary hover:text-red-400 transition-colors text-sm neu-hover touch-manipulation w-full sm:w-auto"
                whileHover={{ scale: 1.02, y: -1 }}
                whileTap={{ scale: 0.98 }}
                transition={springConfig}
              >
                Sign Out
              </motion.button>
            </div>
          </div>
        </div>
      </header>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-8">
        <div className="flex flex-col lg:flex-row gap-4 sm:gap-8">
          {/* Sidebar Navigation */}
          <aside className="lg:w-64 flex-shrink-0">
            <nav className="neu p-3 sm:p-4 space-y-1 sm:space-y-2">
              {navItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) =>
                    `flex items-center gap-2 sm:gap-3 px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl transition-all neu-hover touch-manipulation ${
                      isActive
                        ? 'bg-accent text-text-primary-dark shadow-sm'
                        : 'text-text-primary/70 hover:text-text-primary'
                    }`
                  }
                >
                  <span className="text-base sm:text-lg">{item.icon}</span>
                  <span className="font-medium text-sm sm:text-base">{item.label}</span>
                </NavLink>
              ))}
            </nav>
          </aside>

          {/* Main Content */}
          <main className="flex-1 min-w-0">
            <Routes>
              <Route path="projects" element={<DashboardProjects />} />
              <Route path="bio" element={<DashboardBio />} />
              <Route path="social" element={<DashboardSocialLinks />} />
              <Route path="content" element={<DashboardContent />} />
              <Route path="resume" element={<DashboardResume />} />
              <Route path="services" element={<DashboardServices />} />
              <Route path="management/*" element={<DashboardManagement />} />
              <Route path="settings" element={<DashboardSettings />} />
              <Route path="*" element={<DashboardProjects />} />
            </Routes>
          </main>
        </div>
      </div>
    </div>
  )
}


